import {createAction} from '@reduxjs/toolkit'
import {GetAnalyticsDetailFilter as SetResourceTypeFilter} from 'interfaces'
export const setAnalyticsDetailFilters = createAction<SetResourceTypeFilter>(
  'setAnalyticsDetailFilters',
)
export const setSortAscending = createAction<boolean>('setSortAscending')
export const resetAnalyticsDetailState = createAction(
  'resetAnalyticsDetailState',
)
